export default __webpack_public_path__ + "static/media/jordan_4.54d6da2f.png";